// extracted by mini-css-extract-plugin
module.exports = {"sourceCard":"CurrentOwnerCard_sourceCard__ynoT1","sourceMeta":"CurrentOwnerCard_sourceMeta__7Igl3","value":"CurrentOwnerCard_value__2BWBA"};